module.exports = __webpack_public_path__ + "static/media/img_landing08.772e1839.png";